import React from 'react';
import { getParentUrl } from '@plone/volto/helpers';
import HiERNMemberView from './View';
import { SidebarPortal } from '@plone/volto/components';
import MembersData from './MembersData';

const HiERNMembersEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <HiERNMemberView {...props} path={getParentUrl(props.pathname)} />
      <SidebarPortal selected={selected}>
        <MembersData data={data} block={block} onChangeBlock={onChangeBlock} />
      </SidebarPortal>
    </>
  );
};

export default HiERNMembersEdit;
